// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';

// Components
import Select from 'Common/Select';
import Input from 'Common/Input';
import Icon from 'Common/Icon';

// Helpers
import classNames from 'classnames';

/**
 * <AdvancedFilters /> component.
 */
class AdvancedFilters extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - styles.
   * @prop {object} bootstrap - bootstrap.
   * @prop {object} fields - fields.
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    bootstrap: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
    additonalOptions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    resultsLength: PropTypes.number,
    isStockCarsPage: PropTypes.bool
  };

  /**
   * Renders <AdvancedFilters /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render(): Node {
    const {
      styles,
      bootstrap,
      fields,
      isLoading,
      resultsLength,
      isStockCarsPage
    } = this.props;
    const {
      transmissions,
      fuelTypes,
      colours,
      doors,
      seats,
      mileages,
      insuranceGroup,
      yearFrom,
      yearTo,
      engineSizeFrom,
      engineSizeTo,
      isMobile
    } = this.props.additonalOptions;

    return (
      <div className={styles.formRow}>
        <div className={classNames(styles.formRowItem)}>
          {!isStockCarsPage ? (
            <div className={classNames(styles.doubleSelect)}>
              <Select
                styles={styles}
                bootstrap={bootstrap}
                name={'yearFrom'}
                label={'Year from'}
                options={yearFrom}
                selectedValue={fields.yearFrom}
                isDisabled={isLoading}
                isMobile={isMobile}
              />
              <Select
                styles={styles}
                bootstrap={bootstrap}
                name={'yearTo'}
                label={'Year to'}
                options={yearTo}
                selectedValue={fields.yearTo}
                isDisabled={isLoading}
                isMobile={isMobile}
              />
            </div>
          ) : (
            <div className={styles.inputWrap}>
              <Input
                styles={styles}
                bootstrap={bootstrap}
                name={'keyword'}
                label={'Keyword search'}
                selectedValue={fields.keyword}
                placeholderText={'Keyword search'}
                isValid={!!resultsLength}
              />
              <Icon
                iconName="search"
                size={'default'}
                className={classNames(styles.iconFilter, styles.searchIcon)}
              />
            </div>
          )}
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'doors'}
            label={'Doors'}
            options={doors}
            selectedValue={fields.doors}
            isDisabled={isLoading}
            isMobile={isMobile}
          />
        </div>

        <div className={classNames(styles.formRowItem, styles.customMinWidth)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'fuelType'}
            label={'Fuel type'}
            options={fuelTypes}
            selectedValue={fields.fuelType}
            isDisabled={isLoading}
            isMobile={isMobile}
          />
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'seats'}
            label={'Seats'}
            options={seats}
            selectedValue={fields.seats}
            isDisabled={isLoading}
            isMobile={isMobile}
          />
        </div>

        <div className={classNames(styles.formRowItem, styles.customMinWidth)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'gearBox'}
            label={'Gearbox'}
            options={transmissions}
            selectedValue={fields.gearBox}
            isDisabled={isLoading}
            isMobile={isMobile}
          />

          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'colour'}
            label={'Colour'}
            options={colours}
            selectedValue={fields.colour}
            isDisabled={isLoading}
            isMobile={isMobile}
          />
        </div>

        <div className={classNames(styles.formRowItem, styles.customMaxWidth)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'insuranceGroup'}
            label={'Insurance group'}
            options={insuranceGroup}
            selectedValue={fields.insuranceGroup}
            isDisabled={isLoading}
            isMobile={isMobile}
          />
          <div className={classNames(styles.doubleSelect)}>
            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'engineSizeFrom'}
              label={'Engine size from'}
              options={engineSizeFrom}
              selectedValue={fields.engineSizeFrom}
              isDisabled={isLoading}
              isMobile={isMobile}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'engineSizeTo'}
              label={'Engine size to'}
              options={engineSizeTo}
              selectedValue={fields.engineSizeTo}
              isDisabled={isLoading}
              isMobile={isMobile}
            />
          </div>
        </div>

        {!isStockCarsPage && (
          <div className={classNames(styles.formRowItem)}>
            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'mileage'}
              label={'Mileage'}
              options={mileages}
              selectedValue={fields.mileage}
              isDisabled={isLoading}
              isMobile={isMobile}
            />
            <div className={styles.inputWrap}>
              <Input
                styles={styles}
                bootstrap={bootstrap}
                name={'keyword'}
                label={'Keyword search'}
                selectedValue={fields.keyword}
                placeholderText={'Keyword search'}
                isValid={!!resultsLength}
              />
              <Icon
                iconName="search"
                size={'default'}
                className={classNames(styles.iconFilter, styles.searchIcon)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AdvancedFilters;



// WEBPACK FOOTER //
// ./src/Common/AdvancedFilters/index.js